<div class="theme-wrapper default-theme Lgv_Dynamic">

    <mat-sidenav-container *ngIf="showHeaderFooter$ | async; else barePage">

        <!--Side Nav Mobile-->
        <mat-sidenav #sideNavMobile class="sideNav sideNavMobile" mode="push">
            <div class="branding" *ngIf="lgvCompanySvc.activeCompany$ | async as company">
                <img [src]="company.LogoUrl" *ngIf="HaveCompany" />
                <span class="AppName">{{appName}}</span>
            </div>
            <mat-nav-list *ngIf="lgvNavBuilderSvc.currentNavigation$ | async as sideMenu">
                <!-- Pre-license nav links -->
                <a mat-list-item *ngFor="let item of lgvNavBuilderSvc.preLicenseNavLinks$ | async" (click)="sideNavMobile.close()" [routerLink]="[item.link]"
                    routerLinkActive="active-link">
                    <i class="fa-fw sidebar-icon" [class]="'fa-' + item.icon + ' fa-' + item.iconStyle"></i>
                    &nbsp;
                    {{item.label}}
                </a>

                <hr *ngIf="(lgvNavBuilderSvc.preLicenseNavLinks$ | async)?.length > 0" />

                <!-- Main nav items -->
                <a mat-list-item *ngFor="let item of sideMenu" (click)="sideNavMobile.close()" [routerLink]="[item.link]"
                    routerLinkActive="active-link">
                    <i class="fa-fw sidebar-icon" [class]="'fa-' + item.icon + ' fa-' + item.iconStyle"></i>
                    &nbsp;
                    {{item.label}}
                </a>

                <a mat-list-item *ngIf="sideMenu.length > 0 && authMgr.IsAuth0 && LgvUserSvc.agentHasMailbox" 
                   (click)="LgvUserSvc.onGoToEmail(); sideNavMobile.close()">
                    <i class="fa-regular fa-envelope sidebar-icon fa-fw"></i>
                    &nbsp;
                    Emails
                    <ng-container *ngIf="(LgvUserSvc.numUnreadEmails$ | async) as numUnreadEmails">
                        <span *ngIf="numUnreadEmails > 0" class="badge">({{numUnreadEmails}})</span>
                    </ng-container>
                </a>
            </mat-nav-list>

            <hr />

            <mat-nav-list>
                <a mat-list-item *ngIf="authMgr.IsAuth0 && (((LgvUserSvc.IsAnyAdmin$| async) || (LgvUserSvc.IsAgent$ | async)
                 || (LgvUserSvc.IsPreLicensedAgent$ | async)))"
                    (click)="sideNavMobile.close()" routerLink="/admin/admin-profile">
                    <i class="fa-fw sidebar-icon fa-user-cog fa-regular"></i>
                    &nbsp;
                    Profile
                </a>
                <a mat-list-item *ngIf="authMgr.IsAuth0 && (LgvUserSvc.IsAnyAdmin$ | async)"
                    (click)="onGoToCompanyProfile(); sideNavMobile.close()">
                    <i class="fa-fw sidebar-icon fa-building fa-regular"></i>
                    &nbsp;
                    Company Profile
                </a>
                <a mat-list-item href="https://support.realfinity.io/hc/en-us" target="_blank">
                    <i class="fa-fw sidebar-icon fa-question-circle fa-regular"></i>
                    &nbsp;
                    Support
                </a>
                <a mat-list-item (click)="authMgr.Logout()">
                    <i class="fa-fw sidebar-icon fa-arrow-right-from-bracket fa-regular"></i>
                    &nbsp;
                    Log Out
                </a>
            </mat-nav-list>

        </mat-sidenav>



        <div class="container-fluid">

            <div id="full-page-wrapper" class="row">


                <!-- Side Nav Desktop -->
                <div id="sideNavDesktop" class="sideNav col" [ngClass]="sideNavMode$ | async" *ngIf="authMgr.IsAuthenticated$ | async">

                    <div class="logo-container">
                        <img class="rf-icon wide-logo" src="/assets/images/icons/realfinity-logo-white.svg" (click)="onLogoClicked()" />
                        <img class="rf-icon small-logo" src="/assets/images/icons/realfinity-logo-small-white.svg" (click)="onLogoClicked()" />
                    </div>

                    <div class="Vert-15"></div>

                    <ng-container *ngIf="lgvNavBuilderSvc.currentNavigation$ | async as curNavItems" style="padding-left: 8px;">
                        <nav class="nav flex-column">
                            <!-- Pre-license nav links -->
                            <a *ngFor="let navItem of lgvNavBuilderSvc.preLicenseNavLinks$ | async"
                                [routerLink]="navItem.link" routerLinkActive="active-link" class="nav-link">
                                <ng-container *ngIf="navItem.icon">
                                    <i class="fa-fw sidebar-icon" [class]="'fa-' + navItem.icon + ' fa-' + navItem.iconStyle"></i>
                                    &nbsp;
                                </ng-container>
                                <span class="sidenav-label">{{navItem.label}}</span>
                            </a>

                            <!-- Divider -->
                            <hr *ngIf="(lgvNavBuilderSvc.preLicenseNavLinks$ | async)?.length > 0" />

                            <!-- Main nav items -->
                            <a *ngFor="let navItem of curNavItems" [routerLink]="navItem.link" routerLinkActive="active-link" class="nav-link">
                                <ng-container *ngIf="navItem.icon">
                                    <i class="fa-fw sidebar-icon" [class]="'fa-' + navItem.icon + ' fa-' + navItem.iconStyle"></i>
                                    &nbsp;
                                </ng-container>
                                <span class="sidenav-label">{{navItem.label}}</span>
                            </a>

                            <a (click)="LgvUserSvc.onGoToEmail()" class="nav-link"
                                *ngIf="curNavItems.length > 0 && authMgr.IsAuth0 && LgvUserSvc.agentHasMailbox">
                                <ng-container>
                                    <span class="fa-layers fa-fw">
                                        <i class="fa-regular fa-envelope sidebar-icon fa-fw"></i>
                                        <span class="fa-layers-counter fa-layers-bottom-right" *ngIf="(LgvUserSvc.numUnreadEmails$ | async) > 0">
                                            {{LgvUserSvc.numUnreadEmails$ | async}}
                                        </span>
                                    </span>
                                </ng-container>
                                &nbsp;
                                <span class="sidenav-label" style="padding-left: 8px;">Emails</span>
                            </a>
                        </nav>
                    </ng-container>



                    <!-- bottom / footer menu -->
                    <nav class="sideNavDesktop-footer nav flex-column" *ngIf="authMgr.IsAuthenticated$ | async">
                        <!-- Admin/Agent View -->
                        <ng-container *ngIf="!(authMgr.IsClient$ | async) && (LgvUserSvc.DBUserInfo$ | async) as userInfo">
                            <a routerLinkActive class="nav-link" [matMenuTriggerFor]="toolbarUserMenu">
                                <ng-container>
                                    <ng-container *ngIf="userInfo.profileImageUrl; else defaultUserIcon">
                                        <img class="sidebar-icon" alt="Profile Photo" [src]="userInfo.profileImageUrl">
                                    </ng-container>
                                    <ng-template #defaultUserIcon>
                                        <i class="fa-fw sidebar-icon fa-circle-user fa-regular"></i>
                                    </ng-template>
                                    &nbsp;
                                </ng-container>
                                <span class="sidenav-label">{{ userInfo.firstName }} {{ userInfo.lastName }}</span>
                            </a>

                            <a routerLinkActive class="nav-link" [matMenuTriggerFor]="adminMenu" *ngIf="LgvUserSvc.IsAdmin$ | async">
                                <ng-container>
                                    <i class="fa-fw sidebar-icon fa-cog fa-regular"></i>
                                    &nbsp;
                                </ng-container>
                                <span class="sidenav-label">Admin Tools</span>
                            </a>
                        </ng-container>

                        <!-- Client View -->
                        <ng-container *ngIf="(authMgr.IsClient$ | async) && (LgvClientSvc.ClientInfo$ | async) as cInfo">
                            <a routerLinkActive class="nav-link" [matMenuTriggerFor]="toolbarClientMenu">
                                <ng-container>
                                    <ng-container *ngIf="cInfo.profileImageUrl; else defaultClientIcon">
                                        <img class="sidebar-icon" alt="Profile Photo" [src]="cInfo.profileImageUrl">
                                    </ng-container>
                                    <ng-template #defaultClientIcon>
                                        <i class="fa-fw sidebar-icon fa-circle-user fa-regular"></i>
                                    </ng-template>
                                    &nbsp;
                                </ng-container>
                                <span class="sidenav-label">
                                    {{ cInfo.firstName }} {{ cInfo.lastName }}
                                    <i class="fa-fw fa-chevron-down fa-regular"></i>
                                </span>
                            </a>
                        </ng-container>

                        <a routerLinkActive class="nav-link" (click)="authMgr.Logout()">
                            <ng-container>
                                <i class="fa-fw sidebar-icon fa-arrow-right-from-bracket fa-regular"></i>
                                &nbsp;
                            </ng-container>
                            <span class="sidenav-label">Log Out</span>
                        </a>
                        
                    </nav>

                    <mat-menu #adminMenu="matMenu">

                        <div style="width:250px;">
                            <button mat-menu-item [matMenuTriggerFor]="changeBrandMenu"><b>Change Brand</b></button>
                            <div style="margin-top:10px;"></div>
                            <button mat-menu-item routerLink="/admin/admin-public-record-testing">Public
                                Record Testing</button>
                            <button mat-menu-item routerLink="/admin/test/apr-calc">APR Testing</button>
                            <button mat-menu-item routerLink="/admin/test/standard-fields">Standard
                                Fields Testing</button>
                            <button mat-menu-item (click)="onGenerateSampleBatchData()">Add Sample
                                Clients</button>

                            <!-- Hide till API accepts agent Id param in pricing search-->
                            <!-- <button mat-menu-item routerLink="/admin/pricing-search">Pricing Search</button>-->

                        </div>


                    </mat-menu>
                    <mat-menu #toolbarUserMenu="matMenu">

                        <ng-container *ngIf="LgvUserSvc.DBUserAssistingAgents$ | async as ImpersonationList">
                            <button mat-menu-item [matMenuTriggerFor]="impersonateMenu"
                                *ngIf="ImpersonationList.length > 0">Impersonate:</button>
                        </ng-container>
                        <mat-divider></mat-divider>
                        <button
                            *ngIf="authMgr.IsAuth0 && (((LgvUserSvc.IsAnyAdmin$| async) || (LgvUserSvc.IsAgent$ | async) 
                            || (LgvUserSvc.IsPreLicensedAgent$ | async)))"
                            mat-menu-item routerLink="/admin/admin-profile">
                            <mat-icon>
                                <fa-icon icon="user-cog"></fa-icon>
                            </mat-icon>
                            <span>Profile</span>
                        </button>
                        <button *ngIf="authMgr.IsAuth0 && (LgvUserSvc.IsAnyAdmin$ | async)" mat-menu-item
                            (click)="onGoToCompanyProfile()">
                            <mat-icon>
                                <fa-icon icon="user-cog"></fa-icon>
                            </mat-icon>
                            <span>Company Profile</span>
                        </button>
                        <button
                            *ngIf="authMgr.IsAuth0 && (LgvUserSvc.IsAnyAdmin$ | async) && !(LgvUserSvc.isOnboarding$| async)"
                            mat-menu-item routerLink="/admin/data-import">
                            <mat-icon>
                                <fa-icon icon="file-csv"></fa-icon>
                            </mat-icon>
                            <span>Data Import</span>
                        </button>
                        <button *ngIf="!authMgr.IsAuth0" mat-menu-item (click)="onOpenEditClientProfileModal()">
                            <mat-icon>
                                <fa-icon icon="user-cog"></fa-icon>
                            </mat-icon>
                            <span>Profile</span>
                        </button>
                        <a style="color: rgba(0, 0, 0, 0.87);" mat-menu-item
                            href="https://support.realfinity.io/hc/en-us" target="_blank">
                            <mat-icon>
                                <fa-icon icon="question-circle"></fa-icon>
                            </mat-icon>
                            <span>Support</span>
                        </a>

                    </mat-menu>

                    <mat-menu #toolbarClientMenu="matMenu">
                        <button mat-menu-item (click)="authMgr.Logout()">
                            <mat-icon>
                                <fa-icon icon="arrow-right-from-bracket"></fa-icon>
                            </mat-icon>
                            <span>Log Out</span>
                        </button>
                    </mat-menu>

                    <mat-menu #impersonateMenu>
                        <ng-container *ngIf="LgvUserSvc.DBUserAssistingAgents$ | async as ImpersonationList">
                            <button *ngFor="let x of ImpersonationList" mat-menu-item
                                (click)="impersonateThisAgentAsAssistant(x.id)">{{x.firstName}}
                                {{x.lastName}}</button>
                        </ng-container>
                    </mat-menu>
                </div>

                <div id="main-area" class="col">

                    <!-- * Header is now only shown for Mobile or UnAuthenticated. -->

                    <!--Mobile Header-->
                    <div id="header" class="toolbar d-lg-none">
                        <ng-container>
                            <mat-toolbar class="mobile-toolbar">

                                <img class="rf-icon small" src="/assets/images/icons/realfinity-logo-small-white.svg"
                                    (click)="onLogoClicked()" />

                                <div class="spacer"></div>

                                <button mat-icon-button (click)="sideNavMobile.open()"
                                    *ngIf="authMgr.IsAuthenticated$ | async">
                                    <fa-icon icon="bars"></fa-icon>
                                </button>

                                <ng-container *ngTemplateOutlet="notAuthenticated"></ng-container>

                            </mat-toolbar>

                        </ng-container>
                    </div>

                    <!--Desktop & Not Authenticated Header-->
                    <div id="header" class="toolbar d-none d-md-block d-lg-block d-xl-block d-xxl-block"
                        *ngIf="authMgr.NotAuthenticated$ | async">
                        <ng-container>
                            <mat-toolbar color="primary">
                                <div class="spacer"></div>

                                <ng-container *ngTemplateOutlet="notAuthenticated"></ng-container>

                            </mat-toolbar>

                        </ng-container>
                    </div>

                    <!--Main Content / Router Outlet-->
                    <div id="main-content" class="content"
                        [@routeAnimations]="o.isActivated && o.activatedRoute.routeConfig.data && o.activatedRoute.routeConfig.data.title">
                        <router-outlet #o="outlet"></router-outlet>
                    </div>

                    <!--Footer-->
                    <div class="footer-container">
                        <!--Agent Footer - should appear for authenticated clients-->
                        <lgv-agent-footer *ngIf="authMgr.IsClient$ | async"></lgv-agent-footer>
                        
                        <!--Company Footer-->
                        <div class="footer" *ngIf="lgvCompanySvc.activeCompany$ | async as activeCompany">
                            <lgv-universal-footer [companyCodeParam]="activeCompany.companyCode"
                                [isCobrandedFooter]="false"></lgv-universal-footer>
                            <small>Rates, terms and conditions are subject to change and may vary based on
                                creditworthiness,
                                qualifications, and collateral conditions. Credit is not guaranteed and will be
                                contingent
                                upon the loan amount and loan program. Borrowers are subject to credit approval.
                                Other
                                restrictions may apply.</small>
                            <div class="Vert-15"></div>
                        
                            <!-- Secret Login Btn -->
                            <div class="password-login" *ngIf="!(authMgr.IsAuthenticated$ | async)">
                                <a title="Password Login" [routerLink]="'/password-login/'"><fa-icon icon="key"></fa-icon></a>
                            </div>
                        </div>
                     
                    </div>
                </div>
            </div>
        </div>
    </mat-sidenav-container>
    <ng-template #barePage>
        <div class="content">
            <router-outlet #o="outlet"></router-outlet>
        </div>
    </ng-template>

    <ng-template #notAuthenticated>
        <ng-container *ngIf="authMgr.NotAuthenticated$ | async">

            <ng-container *ngIf="!OfflineMode && !(LgvClientSvc.isAnonymousClient$ | async)">
                <button id="loginBtn" [matMenuTriggerFor]="loginMenu" class="btn btn-primary btn-margin"
                    *ngIf="(LgvApiSvc.HaveAuth0RegistrationInfo$ | async) !== true && !authMgr.IsTestingClientBearerToken">
                    Log In
                </button>
            </ng-container>

            <!--Login Drop down Menu-->
            <mat-menu #loginMenu="matMenu" style="padding:0;" (closed)="onLoginMenuClosed($event)">

                <div id="loginMenu" class="container login">
                    <div class="row" *ngIf="!ClientLoginMode">
                        <div class="col-6 agentLogin">
                            <button class="btn btn-secondary" (click)="authMgr.Auth0Login()">Agent Log in</button>
                        </div>
                        <div class="col-6 clientLogin">
                            <button (click)="ClientLoginMode = true; $event.stopPropagation()"
                                class="btn btn-secondary">Client Log in</button>
                        </div>
                    </div>

                    <div class="row" *ngIf="ClientLoginMode">
                        <div class="col-12 clientLoginPanel">
                            <div *ngIf="ClientInvitationRequestStatus$ |async as requestStatus">

                                <!--Error-->
                                <div *ngIf="requestStatus == 'Error'">
                                    <div>
                                        <a>Close <fa-icon icon="times"></fa-icon></a>
                                    </div>
                                    <div class="Vert-15"></div>
                                    <div class="alert alert-info">
                                        We were not able to re-send your invitation to
                                        <b>{{ClientEmail}}</b>. Please check the email address and try again or try
                                        another email address.
                                    </div>
                                </div>

                                <!--Success-->
                                <div *ngIf="requestStatus == 'Success'">
                                    <div>
                                        <a>Close <fa-icon icon="times"></fa-icon></a>
                                    </div>
                                    <div class="Vert-15"></div>

                                    <div class="alert alert-info">
                                        An email with a new invitation has been sent to
                                        <b>{{ClientEmail}}</b>.
                                    </div>
                                </div>

                                <!--None-->
                                <div *ngIf="requestStatus == 'None'" (click)="$event.stopPropagation()">

                                    <!--No Token Mode-->
                                    <ng-container *ngIf="!(HaveExpiredToken$ | async)">
                                        <div>
                                            <a (click)="ClientLoginMode = false; $event.stopPropagation()">
                                                <fa-icon icon="arrow-left"></fa-icon>
                                            </a>
                                        </div>
                                        <div class="Vert-15"></div>
                                        <div>
                                            <p>Access to the site is only granted by invitation. If you no longer have
                                                <b>your email invitation from
                                                    your Loan Advisor</b>, enter your email address
                                                below and we will send you a new invitation link.
                                            </p>
                                        </div>
                                        <div>
                                            <form [formGroup]="ClientLoginForm" style="text-align:right;">
                                                <div (click)="$event.stopPropagation()">
                                                    <input type="text" id="email" formControlName="email"
                                                        required /><br />
                                                    <span *ngIf="!ClientLoginForm.valid" class="invalidLink">Submit
                                                        <fa-icon icon="arrow-right"></fa-icon></span>
                                                    <a *ngIf="ClientLoginForm.valid"
                                                        (click)="onSubmitClientEmail()">Submit <fa-icon
                                                            icon="arrow-right"></fa-icon></a>
                                                    <!--<button id="btnSubmit" class="btn btn-primary btn-margin" (click)="onSubmitClientEmail()" [disabled]="!ClientLoginForm.valid">Submit</button>-->
                                                </div>

                                                <div
                                                    *ngIf="ClientEmailField.invalid && (ClientEmailField.dirty || ClientEmailField.touched)">
                                                    <div *ngIf="ClientEmailField.errors.required">
                                                        Email address is required.
                                                    </div>
                                                    <div *ngIf="ClientEmailField.errors.email">
                                                        Please enter a valid email address.
                                                    </div>
                                                </div>

                                            </form>

                                        </div>

                                    </ng-container>

                                    <!--Expired Token Mode-->
                                    <ng-container *ngIf="HaveExpiredToken$ | async">

                                        <mat-card>
                                            <mat-card-subtitle rtl>
                                                <p>Hi {{ClientInfo.firstName}} - </p>
                                                <p>Unfortunately, the link you used has expired.
                                                    Click the button below to send a new link to your email address
                                                    <b>{{ClientInfo.email}}</b>
                                                </p>
                                                <div class="Vert-25 col-12"></div>
                                                <p><button class="btn btn-primary" (click)="onRefreshToken()">Send me a
                                                        new link to
                                                        {{ClientInfo.email}}</button></p>
                                            </mat-card-subtitle>
                                        </mat-card>

                                    </ng-container>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </mat-menu>

        </ng-container>

    </ng-template>
</div>